import Download16 from '@carbon/icons-react/es/download/16';
import React, { FC } from 'react';
import { Button, ButtonProps } from 'components/atoms/button/button';

export const DownloadButton: FC<ButtonProps> = (props) => (
  <Button
    icon={<Download16 fill="white" />}
    type="text"
    iconPlacement="right"
    {...props}
  />
);
